const userTypes = {
    EMAIL_SIGN_IN: 'EMAIL_SIGN_IN',
    CHECK_USER_SESSION: 'CHECK_USER_SESSION',
    SET_USER_PROFILE_DATA: 'SET_USER_PROFILE_DATA',
    SET_STUDENT_DATA: 'SET_STUDENT_DATA' 
}

export default userTypes